module.exports = __webpack_public_path__ + "img/notifications.be0d6481.svg";